import type { ReactNode } from 'react';
import { Body1, Button, Caption1, Title3, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalXXL,
    border: `1px dashed ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground2,
  },
  icon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: tokens.colorBrandForeground1,
  },
  description: {
    color: tokens.colorNeutralForeground3,
    maxWidth: '64ch',
  },
});

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  footer?: ReactNode;
}

export function EmptyState({ action, description, footer, icon, title }: EmptyStateProps) {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      {icon ? <div className={styles.icon}>{icon}</div> : null}
      <Title3>{title}</Title3>
      {description ? <Body1 className={styles.description}>{description}</Body1> : null}
      {action ? <Button appearance="primary" onClick={action.onClick}>{action.label}</Button> : null}
      {footer ? <Caption1>{footer}</Caption1> : null}
    </div>
  );
}
